import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import linkify from 'vue-linkify';
import Axios from 'axios';
import Moment from 'moment';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { is_not} from 'vee-validate/dist/rules';
import locales from './locales/zh_tw';
import mixins from '@/mixins';
import setting from '@/setting';
import helpers from '@/helpers/helpers.js'
import SlideUpDown from 'vue-slide-up-down';
import DatePicker from 'vue2-datepicker';
import TextareaAutosize from 'vue-textarea-autosize';
import { TiptapVuetifyPlugin } from 'tiptap-vuetify';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/zh-tw';
import 'tiptap-vuetify/dist/main.css';
import 'vuetify/dist/vuetify.min.css';
import VueI18n from 'vue-i18n';
import zhTW from './__vue2cmsstonevuetify/assets/langs/zh_TW'; //建立放語言的檔案並在此引入
import zhCN from './__vue2cmsstonevuetify/assets/langs/zh_CN'; //建立放語言的檔案並在此引入
import ja from './__vue2cmsstonevuetify/assets/langs/ja'; //建立放語言的檔案並在此引入
import us from './__vue2cmsstonevuetify/assets/langs/us'; //建立放語言的檔案並在此引入
import H_axios from '@/helpers/axios';

Vue.config.productionTip = false;
Axios.defaults.headers.common['Content-Type'];
Axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
Axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
Vue.prototype.$axios = Axios;
Vue.prototype.$moment = Moment;
Vue.prototype.$locales = locales;

Vue.mixin(mixins);
Vue.mixin(setting);
Vue.mixin(helpers);
Vue.directive('linkified', linkify);

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
extend('is_not', {...is_not})
Vue.component('SlideUpDown', SlideUpDown);
Vue.component('DatePicker', DatePicker);

Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'mdi',
});
Vue.use(TextareaAutosize);
Vue.use(VueI18n);

//i18n
const language = (
  navigator.language || navigator.browserLanguage
).toLowerCase();
let tar_locale = '';
if (store.state.locale.selectingLocale) {
  tar_locale = store.state.locale.selectingLocale;
} else {
  tar_locale = language ? language : 'zh-tw';
}
const messages = {
  tw: zhTW,
  'zh-tw': zhTW,
  cn: zhCN,
  'zh-cn': zhCN,
  ja: ja,
  us: us,
};
const i18n = new VueI18n({
  locale: tar_locale,
  fallbackLocale: 'zh-tw',
  messages,
});

const files = require.context(
  '@/__vue2cmsstonevuetify/components/',
  true,
  /\.vue$/i,
);
files.keys().map((key) =>
  Vue.component(
    key
      .split('/')
      .pop()
      .split('.')[0],
    files(key).default,
  ),
);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');

H_axios.setupInterceptors();